"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartTooltip = void 0;
var React = __importStar(require("react"));
var Mana_1 = require("../Mana/Mana");
var utils_1 = require("./utils");
require("./BarChart.css");
var BarChartTooltip = function (_a) {
    var active = _a.active, payload = _a.payload, network = _a.network, isMana = _a.isMana;
    if (active && payload && payload.length && payload[0].payload.amount) {
        var values = payload[0].payload.values;
        var isLatestRange = values[0] === values[1];
        var lowerBound = (0, utils_1.formatAndRoundNumberString)(values[0].toString());
        var lowerBoundLabel = (React.createElement("span", null, isLatestRange ? "".concat(lowerBound, "+") : lowerBound));
        var upperBoundLabel = (React.createElement("span", null, (0, utils_1.formatAndRoundNumberString)(values[1].toString())));
        return (React.createElement("div", { className: "custom-tooltip" },
            isMana ? (React.createElement(Mana_1.Mana, { network: network }, lowerBoundLabel)) : (lowerBoundLabel),
            !isLatestRange ? (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "custom-tooltip-separator" }, "-"),
                isMana ? (React.createElement(Mana_1.Mana, { network: network }, upperBoundLabel)) : (upperBoundLabel))) : null));
    }
    return null;
};
exports.BarChartTooltip = BarChartTooltip;
